import VueRouter from "vue-router";
import routes from "./routes";

// configure router
const router = new VueRouter({
  mode: "history",
  routes, // short for routes: routes
  linkExactActiveClass: "current-page"
  // scrollBehavior: (to) => {
  //   if (to.hash) {
  //     return {selector: to.hash}
  //   } else {
  //     return {x: 0, y: 0}
  //   }
  // }
});

export default router;
